import React, { ButtonHTMLAttributes, ElementType, FC } from 'react'

import cn from 'classnames'

import classes from './button.module.scss'

/***
 * Design system: https://www.figma.com/file/JRJ2xtZ27FkTiR6GEvt0yuDd/%E2%9D%96-SMARTY-Design-System?type=design&node-id=9654-45956&t=Omj58skJauXiNxZd-0
 */
export enum Level {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  SecondaryLegacy = 'secondaryLegacy',
  SecondaryLegacyYellow = 'secondaryLegacyYellow',
  SecondaryLight = 'secondaryLight',
  Quaternary = 'quaternary',
  Link = 'link',
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  level?: Level
  size?: 'regular' | 'tiny'
  as?: ElementType
  /**
   * Used when `as` is a router Link component.
   * Accepts a string path or a location descriptor object (react-router v5 `LinkProps['to']`).
   */
  to?:
    | string
    | {
        pathname?: string
        search?: string
        hash?: string
        state?: unknown
        key?: string
      }
  dataTestId?: string
  dataItemName?: string
  dataItemCategory?: string
}

export const Button: FC<ButtonProps> = ({
  className,
  level = 'primary',
  size = 'regular',
  dataTestId,
  dataItemName,
  dataItemCategory,
  as: Tag = 'button',
  ...props
}) => {
  return (
    <Tag
      className={cn(classes.root, classes[level], classes[size], className)}
      data-testid={dataTestId}
      {...(dataItemName && { 'data-item-name': dataItemName })}
      {...(dataItemCategory && { 'data-item-category': dataItemCategory })}
      {...props}
    />
  )
}
